// extracted by mini-css-extract-plugin
module.exports = {"colourContainer":"Colours_colourContainer__XPjI_"};